import type { ReactNode } from "react";
import { LegendList } from "@legendapp/list/react";
import { cn } from "@/lib/utils";

export const GOOGLE_DRIVE_VIRTUALIZE_THRESHOLD = 40;

type GoogleDriveVirtualListProps<T extends { id: string }> = {
  items: T[];
  renderItem: (item: T) => ReactNode;
  className?: string;
  estimatedItemSize?: number;
};

export function GoogleDriveVirtualList<T extends { id: string }>({
  items,
  renderItem,
  className,
  estimatedItemSize = 44,
}: GoogleDriveVirtualListProps<T>) {
  if (items.length <= GOOGLE_DRIVE_VIRTUALIZE_THRESHOLD) {
    return (
      <div className={cn("space-y-0.5 overflow-x-hidden w-full", className)}>
        {items.map((item) => (
          <div key={item.id}>{renderItem(item)}</div>
        ))}
      </div>
    );
  }

  return (
    <LegendList<T>
      className={cn(
        "min-h-[120px] max-h-[min(60vh,640px)] overflow-x-hidden w-full",
        className
      )}
      data={items}
      keyExtractor={(item) => item.id}
      estimatedItemSize={estimatedItemSize}
      getEstimatedItemSize={() => estimatedItemSize}
      recycleItems={false}
      drawDistance={320}
      renderItem={({ item }) => (
        <div className="pb-0.5">{renderItem(item)}</div>
      )}
    />
  );
}
